import React from 'react';

const DpeDisplay = ({ property }) => {
  const bgColor = () => {
    switch (property.dpe_energy_letter) {
      case 'A':
        return 'bg-green-500/80';
      case 'B':
        return 'bg-green-400/80';
      case 'C':
        return 'bg-green-300/80';
      case 'D':
        return 'bg-yellow-300/80';
      case 'E':
        return 'bg-orange-300/80';
      case 'F':
        return 'bg-red-300/80';
      case 'G':
        return 'bg-red-500/80';
    }
  };

  if (!property.dpe_energy_letter) return null;

  return (
    <div className='flex items-center gap-2'>
      <p>DPE : </p>
      <div className={`relative flex justify-center items-center w-9 h-9 rounded-xl ${bgColor()}`}>
        <p className='text-ih-neutral font-semibold'>{property.dpe_energy_letter}</p>
      </div>
    </div>
  )
};

export default DpeDisplay;
